import React from 'react';
import { connect } from 'react-redux';
import { updateFeaturesOwnerType } from 'actions';
import { Features } from 'components';
import { FormGroup, ControlLabel, Panel } from 'react-bootstrap';

class PlansPermissionsSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.handleClickToggleOpen = this.handleClickToggleOpen.bind(this);
  }

  handleClickToggleOpen() {
    this.setState({ open: !this.state.open });
    $('.permissions-open-toggle-chevron').toggleClass('open');
  }
  componentDidMount() {
    this.props.updateFeaturesOwnerType('Plan');
  }
  componentWillUnmount() {
    this.props.updateFeaturesOwnerType('Role');
  }

  render() {
    return (
      <FormGroup>
        <ControlLabel
          onClick={this.handleClickToggleOpen}
          className='permissions-open-toggle'
          >
          Select Enabled Permissions
          <span>{'  '}
            <i className='fa fa-chevron-up permissions-open-toggle-chevron' />
          </span>
          <span className='plans-permissios-view-toggle'><i className='chevron-down' /></span>
        </ControlLabel>
        <Panel collapsible expanded={this.state.open}>
          <Features
            handleChange={this.props.handleChange}
            current_entity={this.props.current_entity}
            numOfColumns={3}
          />
        </Panel>
        {this.state.open ? (
          <p
            onClick={this.handleClickToggleOpen}
            className='permissions-open-toggle'
            >
            Close Permissions
            <span>{'  '}<i className='fa fa-chevron-up'/></span>
          </p>
        ): null}
      </FormGroup>
    )
  }
}

export default connect(null, { updateFeaturesOwnerType })(PlansPermissionsSelector);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plans-permissions-selector.js